<template>
<v-flex class="py-3 px-2" xs12 sm8 md6 lg5>
  <v-card class="pa-3 elevation-2">
    <v-form v-model="valid" @submit.prevent="canSignIn">
      <v-layout row wrap justify-center>
        <v-flex class="pb-3 text-xs-center" xs12>
          <div class="headline">Sign In</div>
        </v-flex>
        <v-flex class="pb-2 pl-4 text-xs-center" xs12>
          <span class="mt-1 title">New user?</span>
          <v-btn to="/sign-up" color="primary" depressed small>
            <span>Sign Up</span>
          </v-btn>
        </v-flex>
        <v-flex xs12>
          <v-text-field  
            label="E-mail "
            v-model.trim="user.email"
            prepend-icon="mail"
            validate-on-blur
            autofocus
            required
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-text-field  
            label="Password "
            v-model="user.password"
            prepend-icon="lock"
            type="password"
            required
          ></v-text-field>
        </v-flex>
        <v-flex class="text-xs-center" xs8>
          <v-btn :loading="loading" :disabled="!valid || loading" color="success" type="submit" large block depressed>
            <span>Sign In</span>
          </v-btn>
        </v-flex>
        <v-flex class="mt-2 text-xs-center" xs12>
          <v-btn to="/reset" color="secondary" small outline>
            <span>Forgot Password</span>
          </v-btn>
        </v-flex>
      </v-layout>  
    </v-form>
  </v-card>
</v-flex> 
</template>

<script>
export default {
  data: () => ({
    entering: true,
    loading: false,
    valid: false,
    user: {
      email: '',
      password: ''
    },
    emailRules: [
      v => !!v || 'Please enter an email to sign in',
      v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Invalid email'
    ],
    passwordRules: [
      v => !!v || 'Please enter a password to sign in'
    ]
  }),
  beforeMount () {
    this.load()
  },
  methods: {
    load () {
      let appMsg = {
        type: 'error',
        msg: ''
      }
      if (this.$store.getters.user) {
        appMsg.msg = 'You are already signed in'
        this.$store.dispatch('showAppMsg', appMsg)
        this.$router.push('/')
      } else this.entering = false
    },
    canSignIn () {
      const appMsg = {
        type: 'error',
        msg: ''
      }
      if (this.user.email === '' || !(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.user.email))) {
        appMsg.msg = 'Please enter a valid email'
        this.$store.dispatch('showAppMsg', appMsg)
        return
      }
      if (this.user.password === '') {
        appMsg.msg = 'Please enter a password'
        this.$store.dispatch('showAppMsg', appMsg)
        return
      }
      this.signIn()
    },
    signIn () {
      this.loading = true
      let userRoute = ''
      this.$store.dispatch('signIn', this.user).then(() => {
        const appMsg = {
          type: 'success',
          msg: 'Signed in'
        }
        userRoute = this.$store.getters.userRoute
        if (userRoute !== '') {
          this.$store.dispatch('setUserRoute', '')
          this.$router.push(userRoute)
        } else if (this.$store.getters.user.type === 'Admin') this.$router.push('/dashboard')
        else this.$router.push('/my-courses')
        this.$store.dispatch('loader').then(() => {
          this.$store.dispatch('showAppMsg', appMsg)
          this.loading = false
        })
      }).catch((err) => {
        let message = ''
        if (err.code === 'auth/user-not-found') message = 'User not found. Please sign up first'
        else if (err.code === 'auth/wrong-password') message = 'Wrong password, click/tap "Forgot Password" if you have forgotten your password'
        else message = err.message
        let appMsg = {
          type: 'error',
          msg: message
        }
        this.$store.dispatch('showAppMsg', appMsg)
        this.loading = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/auth/SignIn.vue